import React, { useState, useEffect } from "react";

import FilePlus from "../../../utils/icons/FilePlus";
import Slider from "../../../utils/Slider";

export default function OpCutVideo({
  valid,
  labelButton,
  message,
  onSubmit,
  selectedContent,
}: {
  valid: boolean;
  labelButton?: string;
  message: string;
  onSubmit: Function;
  selectedContent: Content[];
}) {
  const [duration, setDuration] = useState(0);
  const [newFilename, setNewFilename] = useState(null);
  const [slice, setSlice] = useState([0, 0]);

  useEffect(() => {
    let video = document.querySelector('[data-id="op-cut-video"]');
    if (video) {
      let i = setInterval(function () {
        if (video.readyState > 0) {
          setSlice([0, Math.ceil(video.duration / 3)]);
          setDuration(Math.ceil(video.duration));
          clearInterval(i);
        }
        return () => clearInterval(i);
      }, 50);
    }
  }, [selectedContent.map((c) => c.id).join("")]);

  if (selectedContent.length === 0) {
    return null;
  }

  const content = selectedContent[0];
  const isReady = duration > 0;

  return valid ? (
    <>
      <video
        data-id="op-cut-video"
        controls
        width="250"
        src={content.meta?.url}
        className="block"
        style={{ margin: "0 auto" }}
      >
        Sorry, your browser doesn't support embedded videos.
      </video>
      {isReady ? (
        <>
          <div className="center mt1">
            <small>
              from {formatSeconds(slice[0])} to {formatSeconds(slice[1])} ={" "}
              {getDiffLabel(Math.abs(slice[1] - slice[0]))}
            </small>
          </div>
          <Slider
            min={0}
            max={duration}
            step={1}
            defaultValues={[slice[0], slice[1]]}
            onChange={(values) => {
              setSlice(values);
            }}
          />
          <p className="mb1 mt1 tac fz08">
            Pick a starting and ending point of your new video clip.
          </p>
          <input
            key="input"
            type="text"
            className="block fz08 mt1"
            name="filename"
            placeholder="Enter a filename"
            onChange={(e) => setNewFilename(e.target.value)}
          />
          <div className="center mt1">
            <button
              disabled={!newFilename || duration === 0}
              className="secondary"
              onClick={() =>
                onSubmit({
                  filename: newFilename,
                  from: slice[0],
                  to: slice[1],
                })
              }
            >
              {labelButton}
            </button>
          </div>
        </>
      ) : (
        <p className="tac mt1">
          <small>Getting video's duration ...</small>
        </p>
      )}
    </>
  ) : (
    <p className="mb1 mt1 tac fz08 with-icon">
      <FilePlus size={16} className="ib" /> {message}
    </p>
  );
}

function getDiffLabel(seconds: number): string {
  const [diffH, diffM, diffS] = formatSeconds(seconds).split(":").map(Number);
  let str: string[] = [];

  if (diffH > 0) {
    str.push(`${diffH}${diffH !== 1 ? "hours" : "hour"}`);
  }
  if (diffM > 0) {
    str.push(`${diffM}${diffM !== 1 ? "minutes" : "minute"}`);
  }
  if (diffS > 0) {
    str.push(`${diffS}${diffS !== 1 ? "seconds" : "second"}`);
  }

  return str.join(" ");
}

function formatSeconds(sec) {
  let hours = Math.floor(sec / 3600);
  let minutes = Math.floor((sec - hours * 3600) / 60);
  let seconds = sec - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
}
